import type { LanguagesListRow } from "@/admin/entities/languages";
import type { LanguagesListQueryType } from "@/types/graphql/admin.generated";

export function getTableData(data: unknown): {
  nodes: LanguagesListRow[];
  count: number;
} {
  const list = (data as LanguagesListQueryType)?.languages;

  if (!list?.nodes) {
    return { nodes: [], count: 0 };
  }

  return list;
}

export function mapColumns(row: LanguagesListRow) {
  return [row.id, row, row.title, row.native, row.translation, row.createdAt];
}
